import { Divider, Popover } from "@mui/material";
import { IFilterItem } from "pages/discounts";
import { type FC, Fragment, useEffect, useRef, useState } from "react";
import FilterPopupList, { IFilterListItem } from "./FilterPopupList";
import FilterPopupRange from "./FilterPopupRange";
import allEquipment from "services/content/allEquipment";
import FilterPopupLocation from "./FilterPopupLocation";

interface FilterItemProps {
  activeItem: IFilterItem;
  item: IFilterItem;
  items: IFilterItem[];
  setActiveItem: (a: any) => void;
  index: number;
  setFilterValue: (a: any) => void;
}

export interface IPopupTranslations {
  title: string;
  placeholder: string;
}

const examples = {
  certification: [
    {
      value: "A1",
      translation: "A1",
    },
    {
      value: "A2",
      translation: "A2",
    },
    {
      value: "A3",
      translation: "A3",
    },
    {
      value: "RPAS",
      translation: "RPAS",
    },
    {
      value: "VLOS",
      translation: "VLOS",
    },
    {
      value: "DGCA",
      translation: "DGCA",
    },
    {
      value: "LAANC",
      translation: "LAANC",
    },
    {
      value: "A1",
      translation: "A1",
    },
    {
      value: "A1",
      translation: "A1",
    },
  ],
  location: [
    {
      value: "Afghanistan",
      translation: "Afghanistan",
    },
    {
      value: "Albania",
      translation: "Albania",
    },
    {
      value: "Algeria",
      translation: "Algeria",
    },
    {
      value: "Andorra",
      translation: "Andorra",
    },
    {
      value: "Andorra",
      translation: "Andorra",
    },
    {
      value: "Bahrain",
      translation: "Bahrain",
    },
    {
      value: "Bangladesh",
      translation: "Bangladesh",
    },
  ],
};

export enum PopupType {
  list = "LIST",
  range = "RANGE",
  location = "LOCATION",
}

const FilterItem: FC<FilterItemProps> = ({
  activeItem,
  item,
  items,
  index: i,
  setFilterValue,
  setActiveItem,
}) => {
  let dividerDisplay = false;
  const condition1 = activeItem.name === item?.name && i === 0;
  const condition2 =
    (activeItem.name === item?.name && i > 0) ||
    items[i + 1]?.name === activeItem.name;
  const condition3 =
    activeItem.name === items[items.length - 1]?.name && i === items.length - 2;

  if (condition1 || condition2 || condition3) dividerDisplay = true;

  const anchorEl = useRef<any>();
  const [open, setOpen] = useState(false);
  const popupType = useRef<PopupType>();

  const [popupTranslation, setPopupTranslation] = useState<
    IPopupTranslations[]
  >([
    {
      title: "",
      placeholder: "",
    },
  ]);

  const [itemList, setItemList] = useState<IFilterListItem[]>([]);
  const [rangeValue, setRangeValue] = useState<number>(10);
  const [search, setSearch] = useState<string>("");

  const fetchDbItems = () => {
    let dbItems: IFilterListItem[] = [];
    try {
      if (item.name == "certification") {
        dbItems = examples[item.name];
      } else if (item.name == "equipment") {
        const newItems = allEquipment.map(
          (e): IFilterListItem => ({
            translation: e.name,
            value: String(e.id),
            isActive: false,
          })
        );
        dbItems = newItems;
      } else if (item.name == "max-range") {
        dbItems = [];
      } else if (item.name == "free-range") {
        dbItems = [];
      }
    } catch (e) {}

    return dbItems;
  };

  useEffect(() => {
    setFilterValue(itemList.filter((i) => i.isActive));
    // TODO: exhaustive deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemList]);

  useEffect(() => {
    setFilterValue(rangeValue);
    // TODO: exhaustive deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rangeValue]);

  useEffect(() => {
    async function fun() {
      popupType.current = PopupType.list;
      // fetch translations
      if (item.name == "location") {
        setPopupTranslation([
          {
            title: "Search country",
            placeholder: "Location...",
          },
          {
            title: "Search city",
            placeholder: "Location...",
          },
        ]);
        popupType.current = PopupType.location;
        if (item.name in examples) setItemList(examples[item.name]);
      } else if (item.name == "certification") {
        setPopupTranslation([
          {
            title: "Certifications",
            placeholder: "Certification...",
          },
        ]);
        if (item.name in examples) setItemList(examples[item.name]);
      } else if (item.name == "equipment") {
        setPopupTranslation([
          {
            title: "Equipments",
            placeholder: "Equipment...",
          },
        ]);
      } else if (item.name == "max-range") {
        setPopupTranslation([
          {
            title: "Max range",
            placeholder: "Max range...",
          },
        ]);
        popupType.current = PopupType.range;
        if (item.name in examples) setItemList([]);
      } else if (item.name == "free-range") {
        setPopupTranslation([
          {
            title: "Free  range",
            placeholder: "Free range...",
          },
        ]);
        popupType.current = PopupType.range;
        if (item.name in examples) setItemList([]);
      }
      setItemList(fetchDbItems());
    }

    fun();
    // TODO: exhaustive deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.name]);

  const updateListBySearch = () => {
    const activeList = itemList.filter((i) => i.isActive);
    const dbItems = fetchDbItems();
    let newList = dbItems.filter((el) =>
      el.translation.toLowerCase().includes(search.toLowerCase())
    );
    newList = newList.filter(
      (i) => activeList.findIndex((a) => a.value == i.value) < 0
    );

    newList = [...newList, ...activeList];

    setItemList(newList);
  };

  useEffect(() => {
    try {
      updateListBySearch();
    } catch (e) {}
    // TODO: exhaustive deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  // useEffect(() => {
  //   console.log("now", itemList);
  // }, [itemList]);

  return (
    <>
      <Fragment key={item.name}>
        <div ref={anchorEl} className="">
          <div
            className={`search-box__categories-item${
              activeItem.name === item?.name ? " active-item" : ""
            }`}
            onClick={(el) => {
              setActiveItem(item?.name);
              setOpen(true);
            }}
          >
            <p className="subtitle-3">{item?.translation}</p>
          </div>
        </div>
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            display:
              dividerDisplay || i === items.length - 1 ? "none" : "unset",
          }}
        />
      </Fragment>
      {/* {!!anchorEl && ( */}
      <div style={{ backgroundColor: "rgba(0,0,0,0)" }}>
        <Popover
          open={open}
          anchorEl={anchorEl.current}
          onClose={() => setOpen(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {popupType.current == PopupType.list && (
            <FilterPopupList
              popupTranslation={popupTranslation[0]}
              key={item.translation}
              itemList={itemList}
              setItemList={(v: any) => setItemList(v)}
              setSearch={(s: string) => setSearch(s)}
              search={search}
            />
          )}
          {popupType.current == PopupType.range && (
            <FilterPopupRange
              popupTranslation={popupTranslation[0]}
              rangeValue={rangeValue}
              setRangeValue={setRangeValue}
              key={item.translation}
            />
          )}
          {popupType.current == PopupType.location && (
            <FilterPopupLocation
              popupTranslation={popupTranslation[0]}
              key={item.translation}
              itemList={itemList}
              setItemList={(v: any) => setItemList(v)}
            />
            // <FilterPopupDoubleLocation
            //   popupTranslation={popupTranslation}
            //   key={item.translation}
            //   itemList={itemList}
            //   setItemList={(v: any) => setItemList(v)}
            //   setSearch={(s: string) => setSearch(s)}
            //   search={search}
            // />
          )}

          {/* {popupType.current == PopupType.location &&
            activeList.length == 2 &&
            itemList.length == 2 && (

            )} */}
        </Popover>
      </div>
      {/* )} */}
    </>
  );
};
export default FilterItem;
